import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="input-utils"
export default class extends Controller {
  connect() {
  }

  mirror(event) {
    const targetId = event.params.id
    const target = document.getElementById(targetId)
    if (target) {
      target.value = event.target.value
    }
  }
}
